/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createPrebidImportExcludedAuction } from '../fn/prebid-import-excluded-auction/create-prebid-import-excluded-auction';
import { CreatePrebidImportExcludedAuction$Params } from '../fn/prebid-import-excluded-auction/create-prebid-import-excluded-auction';
import { deletePrebidImportExcludedAuction } from '../fn/prebid-import-excluded-auction/delete-prebid-import-excluded-auction';
import { DeletePrebidImportExcludedAuction$Params } from '../fn/prebid-import-excluded-auction/delete-prebid-import-excluded-auction';
import { findPrebidImportExcludedAuctions } from '../fn/prebid-import-excluded-auction/find-prebid-import-excluded-auctions';
import { FindPrebidImportExcludedAuctions$Params } from '../fn/prebid-import-excluded-auction/find-prebid-import-excluded-auctions';
import { FindPrebidImportExcludedAuctionsResponseDto } from '../models/find-prebid-import-excluded-auctions-response-dto';
import { PrebidImportExcludedAuctionDto } from '../models/prebid-import-excluded-auction-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedPrebidImportExcludedAuctionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findPrebidImportExcludedAuctions()` */
  static readonly FindPrebidImportExcludedAuctionsPath = '/api/prebid-import/excluded-auctions';

  /**
   * Gets the auctions excluded from the prebid import.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findPrebidImportExcludedAuctions()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrebidImportExcludedAuctions$Response(params?: FindPrebidImportExcludedAuctions$Params, context?: HttpContext): Observable<StrictHttpResponse<FindPrebidImportExcludedAuctionsResponseDto>> {
    return findPrebidImportExcludedAuctions(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the auctions excluded from the prebid import.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findPrebidImportExcludedAuctions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findPrebidImportExcludedAuctions(params?: FindPrebidImportExcludedAuctions$Params, context?: HttpContext): Observable<FindPrebidImportExcludedAuctionsResponseDto> {
    return this.findPrebidImportExcludedAuctions$Response(params, context).pipe(
      map((r: StrictHttpResponse<FindPrebidImportExcludedAuctionsResponseDto>): FindPrebidImportExcludedAuctionsResponseDto => r.body)
    );
  }

  /** Path part for operation `createPrebidImportExcludedAuction()` */
  static readonly CreatePrebidImportExcludedAuctionPath = '/api/prebid-import/excluded-auctions';

  /**
   * Excludes an auction of a source system from the prebid import.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPrebidImportExcludedAuction()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPrebidImportExcludedAuction$Response(params: CreatePrebidImportExcludedAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidImportExcludedAuctionDto>> {
    return createPrebidImportExcludedAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * Excludes an auction of a source system from the prebid import.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPrebidImportExcludedAuction$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createPrebidImportExcludedAuction(params: CreatePrebidImportExcludedAuction$Params, context?: HttpContext): Observable<PrebidImportExcludedAuctionDto> {
    return this.createPrebidImportExcludedAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<PrebidImportExcludedAuctionDto>): PrebidImportExcludedAuctionDto => r.body)
    );
  }

  /** Path part for operation `deletePrebidImportExcludedAuction()` */
  static readonly DeletePrebidImportExcludedAuctionPath = '/api/prebid-import/excluded-auctions/{id}';

  /**
   * Lifts the exclusion of an auction from the prebid import.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePrebidImportExcludedAuction()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePrebidImportExcludedAuction$Response(params: DeletePrebidImportExcludedAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePrebidImportExcludedAuction(this.http, this.rootUrl, params, context);
  }

  /**
   * Lifts the exclusion of an auction from the prebid import.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePrebidImportExcludedAuction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePrebidImportExcludedAuction(params: DeletePrebidImportExcludedAuction$Params, context?: HttpContext): Observable<void> {
    return this.deletePrebidImportExcludedAuction$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
